import React, { useState, useEffect } from "react";
import axios from "axios";

const CreateAudienceModal = ({
  open,
  onOpenChange,
  onSave,
  editingAudience = null,
}) => {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    ageRange: "",
    location: "",
    income: "",
    education: "",
    painPoints: "",
    goals: "",
  });
  const [interestTags, setInterestTags] = useState([]);
  const [currentInterest, setCurrentInterest] = useState("");
  const [painPoints, setPainPoints] = useState([]);
  const [currentPainPoints, setCurrentpainPoints] = useState("");
  const [preferedChallenges, setPerferedChallenges] = useState([]);
  const [currentPreferedChallenges, setCurrentPreferedChallenges] =
    useState("");
  const [contentPreferences, setContentPreferences] = useState([]);
  const [currentContentPrefrences, setCurrentContentPrefrences] = useState("");
  const [apiError, setApiError] = useState("");

  useEffect(() => {
    if (editingAudience) {
      setFormData({
        id: editingAudience.id || "",
        title: editingAudience.title || "",
        description: editingAudience.description || "",
        ageRange: editingAudience.details?.ageRange || "",
        interests: editingAudience.interests || "",
        pinPointsAndChallenges: editingAudience.pinPointsAndChallenges || "",
        preferredChannels: editingAudience.preferredChannels || "",
        contentPreferences: editingAudience.contentPreferences || "",
        demographics: editingAudience.demographics || "",
        // painPoints: editingAudience.details?.painPoints || "",
        goals: editingAudience.details?.goals || "",
        location: editingAudience.details?.location || "",
        income: editingAudience.details?.income || "",
        education: editingAudience.details?.education || "",
      });
      setInterestTags(editingAudience.details?.interests || []);
      setPainPoints(editingAudience.details?.pinPointsAndChallenges || []);
      setContentPreferences(editingAudience.details?.contentPreferences || []);
      setPerferedChallenges(editingAudience.details?.preferredChannels || []);
    } else {
      setFormData({
        title: "",
        description: "",
        ageRange: "",
        location: "",
        income: "",
        education: "",
        painPoints: "",
        goals: "",
      });
      setInterestTags([]);
      setCurrentpainPoints([]);
      setPerferedChallenges([]);
      setContentPreferences([]);
    }
  }, [editingAudience, open]);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const addInterestTag = () => {
    if (
      currentInterest.trim() &&
      !interestTags.includes(currentInterest.trim())
    ) {
      setInterestTags((prev) => [...prev, currentInterest.trim()]);
      setCurrentInterest("");
    }
  };

  const addContentPreferences = () => {
    if (
      currentContentPrefrences.trim() &&
      !contentPreferences.includes(currentContentPrefrences.trim())
    ) {
      setContentPreferences((prev) => [
        ...prev,
        currentContentPrefrences.trim(),
      ]);
      setCurrentContentPrefrences("");
    }
  };

  const removeContentPreferences = (tag) => {
    setContentPreferences((prev) => prev.filter((t) => t !== tag));
  };

  const addPreferedChallenges = () => {
    if (
      currentPreferedChallenges.trim() &&
      !preferedChallenges.includes(currentPreferedChallenges.trim())
    ) {
      setPerferedChallenges((prev) => [
        ...prev,
        currentPreferedChallenges.trim(),
      ]);
      setCurrentPreferedChallenges("");
    }
  };

  const removePreferedChallenges = (tag) => {
    setPerferedChallenges((prev) => prev.filter((t) => t !== tag));
  };

  const addPainPoints = () => {
    if (
      currentPainPoints.trim() &&
      !painPoints.includes(currentPainPoints.trim())
    ) {
      setPainPoints((prev) => [...prev, currentPainPoints.trim()]);
      setCurrentpainPoints("");
    }
  };

  const removePainPoints = (tag) => {
    setPainPoints((prev) => prev.filter((t) => t !== tag));
  };

  const removeInterestTag = (tag) => {
    setInterestTags((prev) => prev.filter((t) => t !== tag));
  };

  const handleKeyDown = (e, addTag) => {
    if (e.key === "Enter" && !e.nativeEvent.isComposing) {
      e.preventDefault();
      addTag();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    setApiError("");
    if (!formData.title.trim() || !formData.description.trim()) {
      return;
    }
    const payload = {
      name: formData.title,
      description: formData.description,
      ageRange: formData.ageRange,
      location: formData.location,
      incomeLevel: formData.income,
      educationLevel: formData.education,
      interests: interestTags,
      pinPointsAndChallenges: painPoints,
      preferredChannels: preferedChallenges,
      contentPreferences: contentPreferences,
      goalsAndMotivations: formData.goals,
    };
    try {
      if (editingAudience) {
        await axios.put(
          `${process.env.REACT_APP_API}audiences/${formData.id}`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        await axios.post(`${process.env.REACT_APP_API}audiences`, payload, {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the request header
          },
        });
      }
      onOpenChange(false);
    } catch (err) {
      setApiError("Failed to create audience. Please try again.");
      console.error(err);
    }
  };

  const handleClose = () => {
    onOpenChange(false);
  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 dark:bg-opacity-70 flex items-center justify-center z-[99]"
      onClick={handleClose}
    >
      <div
        className="bg-white dark:bg-[#0A0A0A] rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto m-4 p-0"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-8 py-6 border-b border-gray-200 dark:border-gray-700">
          <div>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-[#fff]">
              {editingAudience ? "Edit Audience" : "Add Audience"}
            </h2>
            <p className="text-gray-600 dark:text-gray-400 mt-1">
              {editingAudience
                ? "Update your audience details — refine who they are, what they care about, and what motivates them."
                : "Describe the people you’re creating for — who they are, what they love, and what drives them."}
            </p>
          </div>
          <button
            onClick={handleClose}
            className="text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-400 p-2 rounded-full focus:outline-none focus:ring-2 focus:ring-orange-500"
            style={{ marginRight: "-8px" }}
            aria-label="Close"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {apiError && (
          <div className="bg-red-100 dark:bg-red-900/20 text-red-700 dark:text-red-400 px-4 py-2 rounded mb-4">
            {apiError}
          </div>
        )}

        <form onSubmit={handleSubmit} className="px-8 py-6 space-y-6">
          {/* Basic Information */}
          <div className="space-y-4">
            <h4 className="font-medium text-gray-900 dark:text-[#fff]">
              Who is this audience?
            </h4>

            <div className="space-y-2">
              <label className="text-sm font-semibold text-gray-700 dark:text-gray-300">
                What do you call this audience?
              </label>
              <textarea
                type="text"
                value={formData.title}
                onChange={(e) => handleInputChange("title", e.target.value)}
                className="border border-gray-300 dark:border-gray-600 rounded px-3 py-2 w-full focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white dark:bg-gray-800 text-gray-900 dark:text-[#fff]"
                placeholder="e.g., Busy moms, early-stage founders, or skincare lovers"
                required
              />
            </div>

            <div className="space-y-2">
              <label className="text-sm font-semibold text-gray-700 dark:text-gray-300">
                What’s this audience about?
              </label>
              <textarea
                value={formData.description}
                onChange={(e) =>
                  handleInputChange("description", e.target.value)
                }
                className="border border-gray-300 dark:border-gray-600 rounded px-3 py-2 w-full min-h-[80px] focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white dark:bg-gray-800 text-gray-900 dark:text-[#fff]"
                placeholder="e.g., People who want to save time on marketing and grow their business faster"
                required
              />
            </div>
          </div>

          {/* Demographics */}
          <div className="space-y-4">
            <h4 className="font-medium text-gray-900 dark:text-[#fff]">
              What are they like?
            </h4>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-2">
                <label className="text-sm font-semibold text-gray-700 dark:text-gray-300">
                  Typical age range
                </label>
                <input
                  type="text"
                  value={formData.ageRange}
                  onChange={(e) =>
                    handleInputChange("ageRange", e.target.value)
                  }
                  className="border border-gray-300 dark:border-gray-600 rounded px-3 py-2 w-full focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white dark:bg-gray-800 text-gray-900 dark:text-[#fff]"
                  placeholder="e.g., 25-35 years"
                />
              </div>

              <div className="space-y-2">
                <label className="text-sm font-semibold text-gray-700 dark:text-gray-300">
                  Where they’re mostly based
                </label>
                <input
                  type="text"
                  value={formData.location}
                  onChange={(e) =>
                    handleInputChange("location", e.target.value)
                  }
                  className="border border-gray-300 dark:border-gray-600 rounded px-3 py-2 w-full focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white dark:bg-gray-800 text-gray-900 dark:text-[#fff]"
                  placeholder="e.g., Urban areas, US & UK"
                />
              </div>

              <div className="space-y-2">
                <label className="text-sm font-semibold text-gray-700 dark:text-gray-300">
                  Typical income level
                </label>
                <input
                  type="text"
                  value={formData.income}
                  onChange={(e) => handleInputChange("income", e.target.value)}
                  className="border border-gray-300 dark:border-gray-600 rounded px-3 py-2 w-full focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white dark:bg-gray-800 text-gray-900 dark:text-[#fff]"
                  placeholder="e.g., Middle to high income"
                />
              </div>

              <div className="space-y-2">
                <label className="text-sm font-semibold text-gray-700 dark:text-gray-300">
                  Education background
                </label>
                <input
                  type="text"
                  value={formData.education}
                  onChange={(e) =>
                    handleInputChange("education", e.target.value)
                  }
                  className="border border-gray-300 dark:border-gray-600 rounded px-3 py-2 w-full focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white dark:bg-gray-800 text-gray-900 dark:text-[#fff]"
                  placeholder="e.g., College educated or self-taught professionals"
                />
              </div>
            </div>
          </div>

          {/* Interests */}
          <div className="space-y-4">
            <h4 className="font-medium text-gray-900 dark:text-[#fff]">
              What do they love?
            </h4>

            <div className="space-y-2">
              <label className="text-sm font-semibold text-gray-700 dark:text-gray-300">
                What are they into?
              </label>
              <div className="flex gap-2">
                <textarea
                  type="text"
                  rows={2}
                  placeholder="e.g., Fitness, tech gadgets, personal growth, or design"
                  value={currentInterest}
                  onChange={(e) => setCurrentInterest(e.target.value)}
                  onKeyDown={(e) => handleKeyDown(e, addInterestTag)}
                  className="flex-1 border border-gray-300 dark:border-gray-600 rounded px-3 py-2 focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white dark:bg-gray-800 text-gray-900 dark:text-[#fff]"
                />
                <button
                  type="button"
                  onClick={addInterestTag}
                  className="border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 px-4 py-2 rounded hover:bg-gray-50 dark:hover:bg-gray-800"
                >
                  Add
                </button>
              </div>

              {interestTags.length > 0 && (
                <div className="flex flex-wrap gap-2 mt-2">
                  {interestTags.map((tag) => (
                    <span
                      key={tag}
                      className="bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-gray-600 px-3 py-1 rounded-full text-sm flex items-center gap-1"
                    >
                      {tag}
                      <button
                        type="button"
                        onClick={() => removeInterestTag(tag)}
                        className="text-gray-500 dark:text-gray-400 hover:text-red-500 dark:hover:text-red-400"
                      >
                        ×
                      </button>
                    </span>
                  ))}
                </div>
              )}
            </div>
          </div>

          <div className="space-y-4">
            <h4 className="font-medium text-gray-900 dark:text-[#fff]">
              What drives them?
            </h4>

            <div className="space-y-2">
              <label className="text-sm font-semibold text-gray-700 dark:text-gray-300">
                What do they struggle with?
              </label>
              <div className="flex gap-2">
                <textarea
                  rows={2}
                  type="text"
                  placeholder="e.g., Staying consistent, overthinking content, or juggling too many tasks"
                  value={currentPainPoints}
                  onChange={(e) => setCurrentpainPoints(e.target.value)}
                  onKeyDown={(e) => handleKeyDown(e, addPainPoints)}
                  className="flex-1 border border-gray-300 dark:border-gray-600 rounded px-3 py-2 focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white dark:bg-gray-800 text-gray-900 dark:text-[#fff]"
                />
                <button
                  type="button"
                  onClick={addPainPoints}
                  className="border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 px-4 py-2 rounded hover:bg-gray-50 dark:hover:bg-gray-800"
                >
                  Add
                </button>
              </div>

              {painPoints.length > 0 && (
                <div className="flex flex-wrap gap-2 mt-2">
                  {painPoints.map((pain) => (
                    <span
                      key={pain}
                      className="bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-gray-600 px-3 py-1 rounded-full text-sm flex items-center gap-1"
                    >
                      {pain}
                      <button
                        type="button"
                        onClick={() => removePainPoints(pain)}
                        className="text-gray-500 dark:text-gray-400 hover:text-red-500 dark:hover:text-red-400"
                      >
                        ×
                      </button>
                    </span>
                  ))}
                </div>
              )}
            </div>

            <div className="space-y-2">
              <label className="text-sm font-semibold text-gray-700 dark:text-gray-300">
                What kinds of problems do they like to solve?
              </label>
              <div className="flex gap-2">
                <textarea
                  rows={2}
                  type="text"
                  placeholder="e.g.,  making visuals pop, tweaking designs, spotting what’s working,  boosting engagement"
                  value={currentPreferedChallenges}
                  onChange={(e) => setCurrentPreferedChallenges(e.target.value)}
                  onKeyDown={(e) =>
                    handleKeyDown(e, addPreferedChallenges)
                  }
                  className="flex-1 border border-gray-300 dark:border-gray-600 rounded px-3 py-2 focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white dark:bg-gray-800 text-gray-900 dark:text-[#fff]"
                />
                <button
                  type="button"
                  onClick={addPreferedChallenges}
                  className="border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 px-4 py-2 rounded hover:bg-gray-50 dark:hover:bg-gray-800"
                >
                  Add
                </button>
              </div>

              {preferedChallenges.length > 0 && (
                <div className="flex flex-wrap gap-2 mt-2">
                  {preferedChallenges.map((pain) => (
                    <span
                      key={pain}
                      className="bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-gray-600 px-3 py-1 rounded-full text-sm flex items-center gap-1"
                    >
                      {pain}
                      <button
                        type="button"
                        onClick={() => removePreferedChallenges(pain)}
                        className="text-gray-500 dark:text-gray-400 hover:text-red-500 dark:hover:text-red-400"
                      >
                        ×
                      </button>
                    </span>
                  ))}
                </div>
              )}
            </div>

            <div className="space-y-2">
              <label className="text-sm font-semibold text-gray-700 dark:text-gray-300">
                What kind of content do they love?
              </label>
              <div className="flex gap-2">
                <textarea
                  rows={2}
                  type="text"
                  placeholder="e.g., Quick tips, behind-the-scenes posts, or step-by-step breakdowns"
                  value={currentContentPrefrences}
                  onChange={(e) => setCurrentContentPrefrences(e.target.value)}
                  onKeyDown={(e) =>
                    handleKeyDown(e, addContentPreferences)
                  }
                  className="flex-1 border border-gray-300 dark:border-gray-600 rounded px-3 py-2 focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white dark:bg-gray-800 text-gray-900 dark:text-[#fff]"
                />
                <button
                  type="button"
                  onClick={addContentPreferences}
                  className="border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 px-4 py-2 rounded hover:bg-gray-50 dark:hover:bg-gray-800"
                >
                  Add
                </button>
              </div>

              {contentPreferences.length > 0 && (
                <div className="flex flex-wrap gap-2 mt-2">
                  {contentPreferences.map((pain) => (
                    <span
                      key={pain}
                      className="bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-gray-600 px-3 py-1 rounded-full text-sm flex items-center gap-1"
                    >
                      {pain}
                      <button
                        type="button"
                        onClick={() => removeContentPreferences(pain)}
                        className="text-gray-500 dark:text-gray-400 hover:text-red-500 dark:hover:text-red-400"
                      >
                        ×
                      </button>
                    </span>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Psychographics */}
          <div className="space-y-4">
            {/* <h4 className="font-medium text-gray-900 dark:text-[#fff]">
              Psychographics
            </h4> */}

            <div className="space-y-4">
              <div className="space-y-2">
                <label className="text-sm font-semibold text-gray-700 dark:text-gray-300">
                  What are they aiming for?
                </label>
                <textarea
                  placeholder="e.g., More time freedom, consistent income, or a brand they’re proud of"
                  value={formData.goals}
                  onChange={(e) => handleInputChange("goals", e.target.value)}
                  className="border border-gray-300 dark:border-gray-600 rounded px-3 py-2 w-full min-h-[80px] focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white dark:bg-gray-800 text-gray-900 dark:text-[#fff]"
                />
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-end gap-3 pt-8 border-t border-gray-200 dark:border-gray-700 mt-8">
            <button
              type="button"
              onClick={handleClose}
              className="border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 px-6 py-2 rounded-lg w-full sm:w-auto"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={!formData.title.trim() || !formData.description.trim()}
              className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded-lg w-full sm:w-auto disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {editingAudience ? "Update Audience" : "Create Audience"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateAudienceModal;
